import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";

type DeleteStageModalProps = {
  workflowType: "bid" | "lead";
  isOpen: boolean;
  onClose: () => void;
} & ({ reason: "hasItems"; count: number } | { reason: "lastInGroup"; count?: number });

export function DeleteStageModal({
  isOpen,
  onClose,
  reason,
  count,
  workflowType,
}: DeleteStageModalProps): JSX.Element {
  const itemLabel = workflowType === "bid" ? "bids" : "leads";

  const message =
    reason === "hasItems"
      ? `This stage has ${count} ${itemLabel} in it. Move the ${itemLabel} to other stages before deleting this stage.`
      : "Each stage group must have at least one stage within it. You can either edit the name or create a replacement stage first, then delete this stage.";

  return (
    <Modal open={isOpen} onOpenChange={onClose} maxWidth="400px">
      <Container>
        <Flex column gap={16}>
          <Text h2 fontWeight="600">
            Can't delete stage
          </Text>
          <Text color="sysTextSecondary">{message}</Text>
        </Flex>
        <ButtonContainer>
          <Button buttonType="primary" buttonStyle="default" onClick={onClose}>
            OK
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
}

const Container = styled(Flex)({
  flexDirection: "column",
  gap: 24,
  padding: 24,
});

const ButtonContainer = styled(Flex)({
  justifyContent: "flex-end",
});
